import React, { CSSProperties } from "react";
import { TITLE_MODES } from "../utils/titleDisplaySetting";
import BeltTitle from "./BeltTitle";

interface TaskTitleProps {
  text?: string;
  /** A TITLE_MODES value (Scrolling / Single Line / Multiple Lines). */
  mode?: string;
  /** The title text style (color/size/weight). */
  style?: CSSProperties;
}

// Renders a task title per the user's display mode, mirroring Android's
// TaskTitleDisplayMode: Scrolling (belt), Single Line (ellipsis), or Multiple
// Lines (wrap).
const TaskTitle: React.FC<TaskTitleProps> = ({ text, mode, style }) => {
  const value = text || "No Name";

  if (mode === TITLE_MODES.MULTIPLE_LINES) {
    return <div style={style}>{value}</div>;
  }
  if (mode === TITLE_MODES.SINGLE_LINE) {
    return (
      <div
        style={{
          ...style,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {value}
      </div>
    );
  }
  return <BeltTitle text={value} style={style} />;
};

export default TaskTitle;
